import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import { faComment, faEnvelope } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { theme } from '@/theme/theme'
import { PhishingSimulationPackageExtended, PhishingSimulationVector } from '@/types/phishingSimulations'

const PackageCardSimulationsDetails = ({
  simulationPackage,
}: {
  simulationPackage: PhishingSimulationPackageExtended
}) => {
  const { t } = useTranslation()

  return (
    <Box display="flex" alignItems="center">
      <Box display="flex" alignItems="center">
        <Typography padding={theme.spacing(0, 1)} fontSize={14} fontWeight={theme.typography.fontWeightMedium}>
          {t('simulationLibrary.difficulty')}:
        </Typography>
        <Typography paddingRight={theme.spacing(1)} fontSize={14}>
          {simulationPackage.difficulties &&
            simulationPackage.difficulties[0] +
              '-' +
              simulationPackage.difficulties[simulationPackage.difficulties.length - 1]}
        </Typography>
        <Typography padding={theme.spacing(0, 1)} fontSize={14} fontWeight={theme.typography.fontWeightMedium}>
          {t('simulationLibrary.vector')}:
        </Typography>
        <Box display="flex" gap={theme.spacing(0.5)}>
          {simulationPackage.vectors?.includes(PhishingSimulationVector.SMS) && (
            <FontAwesomeIcon icon={faComment as IconProp} fontSize={16} />
          )}
          {simulationPackage.vectors?.includes(PhishingSimulationVector.Email) && (
            <FontAwesomeIcon icon={faEnvelope as IconProp} fontSize={16} />
          )}
          {simulationPackage.vectors?.includes(PhishingSimulationVector.WhatsApp) && (
            <FontAwesomeIcon icon={faWhatsapp as IconProp} fontSize={16} />
          )}
        </Box>
      </Box>
    </Box>
  )
}
export default PackageCardSimulationsDetails
